import React from 'react';

import { Box } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

const Separator = ({ withBorder = true }: { withBorder?: boolean }): JSX.Element => {
  const { colors } = useTheme();
  return (
    <>
      {withBorder && (
        <Box
          data-testid="separator"
          pt="8x"
          borderBottom={`1px solid ${colors.border.primary.toString()}`}
          width="100%"
        />
      )}
      <Box pb="8x" width="100%" />
    </>
  );
};

export default Separator;
